import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Drag = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb42c__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb42c__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M9.023 15h.013A2.939 2.939 0 0 1 12 17.964v.014A3.039 3.039 0 0 1 8.977 21h-.013A2.939 2.939 0 0 1 6 18.036v-.014A3.039 3.039 0 0 1 9.023 15m14.941 0h.014A3.039 3.039 0 0 1 27 18.023C27 19.634 25.634 21 23.977 21h-.013C22.307 21 21 19.634 21 17.977 21 16.366 22.307 15 23.964 15m15 0h.014A3.039 3.039 0 0 1 42 18.023v.013A2.939 2.939 0 0 1 39.036 21h-.072A2.939 2.939 0 0 1 36 18.036v-.072A2.939 2.939 0 0 1 38.964 15M9.023 27h.013A2.939 2.939 0 0 1 12 29.964v.072A2.939 2.939 0 0 1 9.036 33h-.072A2.939 2.939 0 0 1 6 30.036v-.014A3.039 3.039 0 0 1 9.023 27m15 0C25.634 27 27 28.307 27 29.964v.014A3.038 3.038 0 0 1 23.977 33C22.366 33 21 31.634 21 29.977v-.013C21 28.307 22.366 27 24.023 27m15 0C40.633 27 42 28.307 42 29.964v.014A3.038 3.038 0 0 1 38.977 33C37.367 33 36 31.634 36 29.977v-.013C36 28.307 37.366 27 39.023 27"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
